export default __webpack_public_path__ + "static/media/goals_history@2x.0344bfcd.png";